import * as $ from 'jquery';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Routes, RouterModule } from '@angular/router';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SpinnerComponent } from './shared/spinner.component';
import { ModalDomainComponent } from './modals/modal-domain/modal-domain.component';
import { DatabaseComponent } from './mantenimiento/database/database.component';
import { ServersComponent } from './mantenimiento/servers/servers.component';
import { BackupsComponent } from './mantenimiento/backups/backups.component';

import { AuthGuardService } from './services/auth-guard.service';
import { UserAuthService } from './services/user-auth.service';

import { MainServersComponent } from './mantenimiento/main-servers/main-servers.component';
import { ModalServerComponent } from './modals/modal-server/modal-server.component';
import { ModalAlertComponent } from './modals/modal-alert/modal-alert.component';
import { ModalDatabaseComponent } from './modals/modal-database/modal-database.component';
import { ModalQuoserverComponent } from './modals/modal-quoserver/modal-quoserver.component';
import { ModalBackupComponent } from './modals/modal-backup/modal-backup.component';
import { ModalUserComponent } from './modals/modal-user/modal-user.component';
import { ModalNotificationComponent } from './modals/modal-notification/modal-notification.component';
import { NetworksComponent } from './mantenimiento/networks/networks.component';
import { ModalNetworkComponent } from './modals/modal-network/modal-network.component';
import { ModalQuonetworkComponent } from './modals/modal-quonetwork/modal-quonetwork.component';
import { ModalStorageComponent } from './modals/modal-storage/modal-storage.component';
import { ModalFacturaComponent } from './modals/modal-factura/modal-factura.component';
import { ModalContactoComponent } from './modals/modal-contacto/modal-contacto.component';
import { ModalAddImageComponent } from './modals/modal-add-image/modal-add-image.component';
import { ModalManualComponent } from './modals/modal-manual/modal-manual.component';
import { DomainsComponent } from './mantenimiento/domains/domains.component';
import { SubdomainsComponent } from './mantenimiento/subdomains/subdomains.component';
import { ModalSubdomainComponent } from './modals/modal-subdomain/modal-subdomain.component';
import { AndroidComponent } from './mantenimiento/android/android.component';
import { ModalAndroidComponent } from './modals/modal-android/modal-android.component';
import { ModalInfoComponent } from './modals/modal-info/modal-info.component';
import { QtoolsComponent } from './mantenimiento/qtools/qtools.component';
import { ModalQtoolsComponent } from './modals/modal-qtools/modal-qtools.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
};

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    ModalDomainComponent,
    DatabaseComponent,
    ServersComponent,
    BackupsComponent,
    MainServersComponent,
    ModalServerComponent,
    ModalAlertComponent,
    ModalDatabaseComponent,
    ModalQuoserverComponent,
    ModalBackupComponent,
    ModalUserComponent,
    ModalNotificationComponent,
    NetworksComponent,
    ModalNetworkComponent,
    ModalQuonetworkComponent,
    ModalStorageComponent,
    ModalFacturaComponent,
    ModalContactoComponent,
    ModalAddImageComponent,
    ModalManualComponent,
    DomainsComponent,
    SubdomainsComponent,
    ModalSubdomainComponent,
    AndroidComponent,
    ModalAndroidComponent,
    ModalInfoComponent,
    QtoolsComponent,
    ModalQtoolsComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    NgbModule.forRoot(),
    PerfectScrollbarModule,
    AppRoutingModule,
    Ng2SmartTableModule,
    NgxDatatableModule,
  ],
  providers: [
      AuthGuardService,
      UserAuthService,
      {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  }],
  entryComponents : [
    ModalServerComponent,
    ModalAlertComponent,
    ModalDomainComponent,
    ModalDatabaseComponent,
    ModalQuoserverComponent,
    ModalBackupComponent,
    ModalUserComponent,
    ModalNotificationComponent,
    ModalNetworkComponent,
    ModalQuonetworkComponent,
    ModalStorageComponent,
    ModalFacturaComponent,
    ModalContactoComponent,
    ModalAddImageComponent,
    ModalManualComponent,
    ModalSubdomainComponent,
    ModalAndroidComponent,
    ModalInfoComponent,
    ModalQtoolsComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
